import { useQuery } from "@tanstack/react-query";

import AdvertisementRequest from "@/api/advertisement/advertisement.requests";

export const useGetTimeCodes = (id: number) => {
  return useQuery({
    queryKey: ["time-codes", id],
    queryFn: () => AdvertisementRequest.getTimeCodes(id),
    staleTime: 0,
    enabled: !!id,
  });
};
export const useGetAdvDetail = (id: number) => {
  return useQuery({
    queryKey: ["adv-detail", id],
    queryFn: () => AdvertisementRequest.getAdvDetail(id),
    staleTime: 0,
    enabled: !!id,
  });
};
